import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgIcon } from '@ng-icons/core';
import { finalize } from 'rxjs';
import { CompanyService } from 'src/app/api/services/company.service';
import { APP_CONSTANTS } from 'src/app/core/constant/constants';
import { LoadingComponent } from 'src/app/shared/component/loading/loading.component';
import { CompanyAdmin } from 'src/app/shared/model/admin';
import { ToastService } from '@services/toast.service';
import { handleApiError } from '@utils/handle-api-error';

@Component({
  selector: 'app-companies',
  imports: [CommonModule, LoadingComponent, NgIcon, RouterModule],
  templateUrl: './companies.component.html',
})
export class CompaniesComponent implements OnInit {
  companies: CompanyAdmin[] = [];
  isLoading: boolean = false;

  constructor(
    private companyService: CompanyService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.loadCompanies();
  }

  private loadCompanies(): void {
    this.isLoading = true;
    this.companyService
      .getAllActive()
      .pipe(
        finalize(() => (this.isLoading = false)),
        handleApiError(this.toastService, 'Error al cargar las compañías')
      )
      .subscribe({
        next: (res: any) => {
          this.companies = res.dto?.companys || [];
        },
      });
  }

  companyImage(company: CompanyAdmin): string {
    const url = company?.urlBannerMiniPage;
    if (!url || url.trim() === '') {
      return APP_CONSTANTS.DEFAULT_IMAGE_COMPANY;
    }
    return url;
  }

  companyBanner(company: CompanyAdmin): string {
    const url = company.urlBannerMvv;
    if (!url || url.trim() === '') {
      return APP_CONSTANTS.DEFAULT_BANNER_COMPANY;
    }
    return url;
  }

  isVerified(company: CompanyAdmin): boolean {
    if (company?.verified === '1') {
      return true;
    } else {
      return false;
    }
  }
}
